var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "menu-block" }, [
    _c(
      "div",
      {
        staticClass: "menu-header",
        style: {
          "background-color": _vm.$store.state.page.bg_color
            ? _vm.$store.state.page.bg_color
            : "#bd3a73",
          color: _vm.$store.state.page.text_color
            ? _vm.$store.state.page.text_color
            : "#fff",
        },
      },
      [_vm._v("\n        " + _vm._s(_vm.title) + "\n    ")]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "menu-content" }, [_vm._t("default")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }